import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { BehaviorSubject, map, Observable, switchMap, tap } from 'rxjs';

interface PanicModeResponse {
  data: {
    active: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class PanicService {
  private http = inject(HttpClient);
  environment = inject(ENVIRONMENT);

  private headerPanicStateSubject = new BehaviorSubject<boolean | null>(null);
  public headerIsPanicMode$ = this.headerPanicStateSubject.asObservable();

  loadHeaderStatus() {
    this.getPanicStatus().subscribe((isPanic) =>
      this.headerPanicStateSubject.next(isPanic),
    );
  }

  getPanicStatus(): Observable<boolean> {
    return this.http
      .get<PanicModeResponse>(`${this.environment.cmsApiUrl}/panic-mode`)
      .pipe(
        map((response) => response.data.active),
        tap((isPanic) => this.headerPanicStateSubject.next(isPanic)),
      );
  }

  private putPanicMode(panic: boolean) {
    return this.http.put(`${this.environment.cmsApiUrl}/panic-mode`, {
      data: {
        active: panic,
      },
    });
  }

  togglePanicMode(): Observable<object> {
    return this.getPanicStatus().pipe(
      switchMap((isPanicMode) => {
        const newState = !isPanicMode;

        return this.putPanicMode(newState).pipe(
          tap(() => this.headerPanicStateSubject.next(newState)),
        );
      }),
    );
  }
}
